function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.496 1.147a1 1 0 01.372.372l4.277 7.485a1 1 0 01-.868 1.496H1.723a1 1 0 01-.868-1.496l4.277-7.485a1 1 0 011.364-.372zM6 7.75c-.45 0-.75.35-.75.75s.3.75.75.75.75-.35.75-.75-.3-.75-.75-.75zm.17-4.15h-.368l-.09.014a.5.5 0 00-.36.34l-.018.085-.002.09.14 2.4.013.086a.5.5 0 00.319.356l.081.022.087.007h.057l.086-.007a.5.5 0 00.374-.298l.026-.08.013-.086.142-2.414-.008-.105-.023-.084a.502.502 0 00-.294-.295l-.085-.023-.09-.008z"
});

function SvgWarningInline(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgWarningInline;